import { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import ota from './ota'
export default () => useContext(ThemeContext) || ota
